module.exports = __webpack_public_path__ + "static/media/cyuce014.e95b355a.jpg";